"use client";

import { useEffect } from "react";

const LICENSE_KEY = "CN-LIC-92FB-97BE-6C68";

export function LicenseCheck() {
  useEffect(() => {
    const tokenKey = `cn_token_${LICENSE_KEY}`;
    const token = localStorage.getItem(tokenKey) || "";
    fetch(`/api/license/verify?key=${LICENSE_KEY}`, {
      headers: { "X-License-Token": token },
    })
      .then((r) => r.json())
      .then((d) => {
        if (d.token) localStorage.setItem(tokenKey, d.token);
        if (!d.valid) document.documentElement.dataset.cnInvalid = "1";
      })
      .catch(() => {});
  }, []);

  return null;
}
